import { StatusPill, toneOfColor } from "../../ui/status-pill"

type CatalogEntry = {
  code: string
  name?: string
  sentName?: string | null
  color?: string | null
}

type Props = {
  code: string | null | undefined
  catalog: ReadonlyArray<CatalogEntry>
  /** Which catalog field to use as the label. Defaults to "name". */
  labelField?: "name" | "sentName"
  fallback?: string
}

/** Catalog status (ORDER_STATUS, delivery-note, payment, invoice…) as the shared status pill; the catalog colour picks the tone. */
export function StatusBadge({ code, catalog, labelField = "name", fallback = "-" }: Props) {
  const entry = catalog.find((c) => c.code === code)
  const label = (labelField === "sentName" ? entry?.sentName : entry?.name) ?? fallback
  return <StatusPill tone={entry ? toneOfColor(entry.color) : "gray"}>{label}</StatusPill>
}
